/**
 * Formats a code/name label for admin tables and tooltips.
 *
 * @param code Entity code.
 * @param name Optional entity name.
 * @returns Combined code and name label.
 */
export const getCodeNameString = (code: string, name: string | undefined | null): string =>
    `${code}${name ? ` - ${name}` : ''}`;
